export default ['$filter', ($filter) => {
    return {
        formatShortDate: (date) => {
            return $filter('date')(new Date(date), 'shortDate');
        }
    };
}];
